// extracted by mini-css-extract-plugin
export var category = "_hk-9";
export var categoryHeader = "_hk-e";
export var container = "_hk-0";
export var group = "_hk-a";
export var groupItems = "_hk-f";
export var groupSeparator = "_hk-j";
export var loading = "_hk-1";
export var noResults = "_hk-3";
export var placeholder = "_hk-2";
export var resultContent = "_hk-5";
export var resultIcon = "_hk-c";
export var resultItem = "_hk-g";
export var resultMeta = "_hk-8";
export var resultSubtitle = "_hk-7";
export var resultSuffix = "_hk-i";
export var resultTitle = "_hk-6";
export var resultsList = "_hk-4";
export var searchGroup = "_hk-d";
export var selected = "_hk-h";
export var subgroup = "_hk-b";